"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var platform;
        (function (platform) {
            var clients;
            (function (clients) {
                class InitArgs {
                    constructor() {
                        this.columnCount = 0;
                        this.columnWidths = 0;
                        this.platformCreateClient = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable = null;
                function init(args) {
                    _initArgs = args;
                    createDataTable();
                }
                clients.init = init;
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sAjaxSource: 'ClientsDataTable',
                        fnServerData: function (data) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')));
                        },
                        autoWidth: false,
                        aoColumns: getDtColConfiguration(),
                        fnInitComplete: function () {
                            $('#addnew').click(function (event) {
                                event.preventDefault();
                                appn.location.navTo(_initArgs.platformCreateClient);
                            });
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildCheckbox(appn.strings.showRetired, 'saveMeState', 'sCustom_0')).append($('.dt-action-button'));
                            appn.dataTable.addSearchPlaceholder(T('Filter results where the Clients <b>Name or Status</b> contains a keyword typed in here.'));
                            $('.dataTables_controls_start').append($('.dt-action-title'));
                            appn.saveMeState.init(function () {
                                _dataTable.fnDraw(false);
                            }, function () {
                                _dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        },
                        fnDrawCallback: function () {
                            $('.viewUserAudit').off().on('click', function (event) {
                                event.preventDefault();
                                const auditUrl = $(this).attr('href');
                                appn.iframe.openModal({
                                    url: auditUrl,
                                    size: 'modal-xl'
                                });
                            });
                        }
                    });
                }
                function getDtColConfiguration() {
                    const aoColumns = [];
                    aoColumns.push({ bSortable: true, sWidth: '35%' });
                    for (let i = 1; i < _initArgs.columnCount; i++)
                        aoColumns.push({ bSortable: true, sWidth: `${_initArgs.columnWidths}%` });
                    aoColumns.push({ bSortable: true, sWidth: '15%' }, { bSortable: true, sWidth: '15%' });
                    return aoColumns;
                }
            })(clients = platform.clients || (platform.clients = {}));
        })(platform = views.platform || (views.platform = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
